<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-6 col-md-6 mg-a">
        @if (clntDtls && clntDtls.length > 0) {
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
      </div>
      @if (tntLst.length>1) {
      <div class="col-lg-6 col-md-6 mg-a" style="text-align: right">
        <span>Select ULB:</span>
        <nz-select
          class="slctBx"
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          @for (t of tntLst; track t) {
          <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst && tntLst.length==1) {
      <div class="col-lg-6 col-md-6 mg-a" style="text-align: right">
        <span>ULB:</span>
        <span class="disbledtxt" style="background: #fff">{{
          tntLst[0].tnt_nm
        }}</span>
      </div>
      }
    </div>
  </div>
</div>

<!-- <div class="fltrbg">
<div class="row">

  <div class="col-lg-2 col-md-2 crdCl" *ngIf="tntLst.length>1">
    <p class="slctlbl">ULB</p>
    <nz-select class="slctBx" nzShowSearch [(ngModel)]="selectedtenant" (ngModelChange)="ontntSelect($event)"
      [ngModelOptions]="{standalone: true}">
      <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
      <nz-option *ngFor="let t of tntLst" [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
    </nz-select>
  </div>
  <div class="col-lg-2 col-md-2 crdCl" *ngIf="tntLst && tntLst.length==1">
    <p class="slctlbl">ULB</p>
    <p class="slctlbl dsblTxt">{{tntLst[0].tnt_nm}}</p>
  </div>
</div>
</div> -->
<div style="padding: 0px 10px">
  <div class="ds-card grid tbl dwntbl vhclsCmpnt">
    <app-data-grid
      class="p-8"
      style="width: 100%"
      [dataSource]="vhcleslst"
      [legacyColumns]="vhclslstcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="Sachivalayam assigned Vehicles Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="150"
        caption="change Sachivalayam"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="openSlider(data)">
            <i nz-icon nzType="car" nzTheme="outline"></i>
          </div></div
      ></ng-template>

      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="true"
        type="buttons"
        [width]="150"
        caption="remove Sachivalayam"
        cellTemplate="editTemplate2"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate2" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="deletePopup(data)">
            <i nz-icon nzType="car" nzTheme="outline"></i>
          </div></div
      ></ng-template>
    </app-data-grid>
  </div>
</div>
<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="400"
  [nzVisible]="opensldr"
  nzTitle="Change Sachivalayam"
  (nzOnClose)="closeSideBar()"
>
  <ng-container *nzDrawerContent>
    <form nz-form class="drvrDtlsfrm">
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-label>Vehicle</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select Vehicle"
                [(ngModel)]="asrt_id"
                [ngModelOptions]="{ standalone: true }"
                nzDisabled
              >
                @for (v of asrtList; track v) {
                <nz-option
                  [nzLabel]="v.asrt_nm"
                  [nzValue]="v.asrt_id"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="24">
          <nz-form-label>Sachivalayam</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                class="slctBx"
                nzShowSearch
                [(ngModel)]="svm_id"
                (ngModelChange)="onsvmSelect($event)"
                [ngModelOptions]="{ standalone: true }"
                nzPlaceHolder="Select Sachivalayam to be changed"
              >
                @for (s of svmLst; track s) {
                <nz-option
                  [nzValue]="s.svm_id"
                  [nzLabel]="s.svm_nm"
                ></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <div class="btngrp">
      <button
        nz-button
        style="margin-right: 8px"
        (click)="closeSideBar()"
        nzType="primary"
        nzDanger
      >
        Cancel
      </button>
      <button nz-button (click)="saveasgnmnt()" class="sbmtbtn">
        Change Sachivalayam
      </button>
    </div>
  </ng-container>
</nz-drawer>
